export default class ErrorHelper {
  constructor() {
    throw 'Não é possível instanciar ErrorHelper';
  }

  static trataMensagem(error) {
    let message = 'Ocorreu um erro inesperado, tente novamente mais tarde.';

    if (!!error && !!error.body && !error.data) {
      message = Array.isArray(error.body)
        ? error.body[0].message
        : error.body.message;
    }

    if (!!error && !!error.data) {
      message = Array.isArray(error.data)
        ? error.data[0].message
        : error.data.message;
    }

    if (!!error && !!error.message && typeof error.message === 'string') {
      message = error.message;
    }

    return message;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/ErrorHelper.js